// removed by extract-text-webpack-plugin
module.exports = {"component":"_33xBRenLXrmJZm5AE4m6nZ","header":"_2hpLMTrgCQ8igGVON4nZmQ","helpText":"_23cbWqXn7AIrNqZP5T-ZtM","form":"_3kxZZAmY7hWkVocSUGp5v3","group":"pZoeAnalWbkFrP_DVCMHY","groupStacked":"ncUQ9FITs0DTl-QQOsJ99","dateFilter":"_3T1gWf-JvxApxPvLhdhd5n","label":"_33WxTDpmi4sdAswkhaFxn8","controlContainer":"_3XCs6rUi_vvx41EvXmZ3d4","control":"jER7eZeiNpC1lgZVjd5uy","textarea":"_2r9SKfMrOwd9jcSItUm42Y","btn":"z8h6qB6_cCSxbhXL5kVrf","margins":"_3bCzd5A61_UmIRVkhWVeFk","textAreaContainer":"_20peX5Ke8467jlPObN7mcs","checkboxLabel":"_3JSNmQeeQ-98F9K55tlJMg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Account/CreateNewUser/CreateNewUser.css
// module id = 1481
// module chunks = 0